// extracted by mini-css-extract-plugin
export default {"closeBtn":"nli26ILh"};